import React from "react";
import { Alert, Button } from "reactstrap";
import { useAuth } from "../Auth/auth";

const ImpersonationBanner = () => {
  const { user } = useAuth();
  if (!localStorage.getItem("impersonation")) return null;

  const exit = () => {
    localStorage.removeItem("impersonation");
    localStorage.removeItem("token");
    window.location.replace(process.env.REACT_APP_OPC_URL + "/admin/box_customer_impersonations");
  };

  return (
    <Alert color="danger" className="d-flex justify-content-between align-items-center mb-0" style={{ borderRadius: 0 }}>
      <span><strong>Impersonation mode</strong>{user ? ` — viewing as ${user.email}` : ""}</span>
      <Button color="light" size="sm" onClick={exit}>Exit impersonation</Button>
    </Alert>
  );
};

export default ImpersonationBanner;
